function showWithTwoDecimals(money?: string) {
  if (!money) {
    return "0.00";
  }
  const decimalPlaces = money.split(".");
  if (decimalPlaces.length === 1) {
    return `${money.replace(".", "")}.00`;
  }
  return decimalPlaces?.[1].length === 1 ? `${money}0` : money;
}

function convertToMoneyFormat(money?: string, currency?: string) {
  const cleanMoney = showWithTwoDecimals(money);
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency ?? "USD",
  });
  return formatter.format(parseFloat(cleanMoney));
}

function getCurrencySymbol(currency: string) {
  switch (currency ?? "") {
    case "USD":
      return "$";
    case "SAR":
      return "SAR ";
    default:
      return currency;
  }
}

export default {
  showWithTwoDecimals,
  convertToMoneyFormat,
  getCurrencySymbol,
};
